import React, { Dispatch, Fragment, SetStateAction, useEffect, useState } from 'react';
import '../../../../../assets/scss/preview.css';
import { safObjectHelper } from '../../../../../utils/SafObjectHelper.ts';
import { companyApi } from '../../../../../modules';
import { codeApi } from '../../../../../api/code.api.ts';

interface IProps {
  ref?: any;
  formCode?: string;
  section?: any;
  data: any;
}

const View = (props: IProps) => {
  const [companyName, setCompanyName] = useState<any>();
  const [manpowerOptions, setManpowerOptions] = useState<any>([]);
  useEffect(() => {
    codeApi.getManpowerCodeList().then((list) => {
      setManpowerOptions(list);
    });
  }, []);
  useEffect(() => {
    if (!props.data?.companyId) return;
    companyApi.getCompanyDetail({ companyId: props.data.companyId }).then((res) => {
      setCompanyName(res.resultObject.companyName);
    });
  }, [props.data?.companyId]);
  return (
    <div>
      <table className={'preview-table preview-bottom-border'}>
        <colgroup>
          <col width={'5%'} />
          <col width={'5%'} />
          <col width={'5%'} />
          <col width={'5%'} />
          <col width={'5%'} />
          <col width={'5%'} />
          <col width={'10%'} />
          <col width={'10%'} />
        </colgroup>
        <tbody>
          <tr>
            <td> Location / Unit No. </td>
            <td colSpan={4} className={'saf-td-center'}>
              {props.data?.locationText}
            </td>
            <th rowSpan={3} className={'saf-bg-white'}>
              Originator
            </th>
            <th className={'saf-bg-white'}>Name</th>
            <th className={'saf-bg-white'}>Signature</th>
          </tr>
          <tr>
            <td> Validity Period </td>
            <td colSpan={4} className={'saf-td-center'}>
              {props.data?.validStartTime &&
                safObjectHelper.formatDateTime(props.data?.validStartTime) +
                  ' ~ ' +
                  safObjectHelper.formatDateTime(props.data?.validEndTime)}
            </td>
            <td rowSpan={2}></td>
            <td rowSpan={2}></td>
          </tr>
          <tr>
            <td> Work Time </td>
            <td colSpan={4} className={'saf-td-center'}>
              {safObjectHelper.formatTimeDifference(
                props.data?.validStartTime,
                props.data?.validEndTime
              )}
            </td>
          </tr>
          <tr>
            <td> Work Description </td>
            <td colSpan={7}>{props.data?.description}</td>
          </tr>
          <tr>
            <th rowSpan={2} className={'saf-border-bottom-none saf-bg-white'}>
              Manpower Planning
            </th>
            <th className={'saf-bg-white'}>Lifting Supervisor </th>
            <th className={'saf-bg-white'}>Crane Operator </th>
            <th className={'saf-bg-white'}>Rigger </th>
            <th className={'saf-bg-white'}>Helper </th>
            <td colSpan={3} rowSpan={2} className={'saf-border-bottom-none'}></td>
          </tr>
          <tr>
            <td className={'saf-td-center'}>
              &nbsp;
              {safObjectHelper.calcManPower(
                props.data?.manPower,
                'Lifting Supervisor',
                manpowerOptions
              )}
              &nbsp;
            </td>
            <td className={'saf-td-center'}>
              {safObjectHelper.calcManPower(
                props.data?.manPower,
                'Crane Operator',
                manpowerOptions
              )}
            </td>
            <td className={'saf-td-center'}>
              {safObjectHelper.calcManPower(props.data?.manPower, 'Rigger', manpowerOptions)}
            </td>
            <td className={'saf-td-center'}>
              {safObjectHelper.calcManPower(props.data?.manPower, 'Helper', manpowerOptions)}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default View;
